import { useToast } from '@/components/ui/use-toast'

interface ToastNotificationProps {
  message: string
  duration?: number
  backgroundColor?: string
  color?: string
}

export const useToastNotification = () => {
  const { toast } = useToast()

  const triggerToast = ({
    message,
    duration = 3000,
    backgroundColor = '#f8d7da',
    color = '#EB5757',
  }: ToastNotificationProps) => {
    toast({
      description: message,
      duration: duration,
      style: {
        zIndex: 9999,
        backgroundColor,
        color,
        borderRadius: '5px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      },
    })
  }

  return { triggerToast }
}

export const usePredefinedToasts = () => {
  const { triggerToast } = useToastNotification()

  return {
    validationErrorToast: () =>
      triggerToast({ message: 'Debes completar todos los campos obligatorios.' }),
    networkErrorToast: () =>
      triggerToast({ message: 'Error de red. Por favor, verifica tu conexión.' }),
    genericErrorToast: () =>
      triggerToast({ message: 'Ocurrió un error inesperado. Inténtalo más tarde.' }),
  }
}
